export interface AccessoryTypeField {
  type: "select" | "number" | "boolean" | "text" | "textarea" | "checkbox" | "radio";
  label: string;
  options?: string[];
  min?: number;
  max?: number;
  step?: number;
  required?: boolean;
  group?: string;
}

export interface AccessoryTypeSpec {
  code: string;
  name: string;
  description: string;
  category: string;
  objectType: "accessories";
  fields: Record<string, AccessoryTypeField>;
}

export const ACCESSORY_TYPE_SPECS: Record<string, AccessoryTypeSpec> = {
  ELE: {
    code: "ELE",
    name: "Elettronica",
    description: "Strumentazione, GPS, ecoscandagli, plotter, radar",
    category: "ELETTRONICA",
    objectType: "accessories",
    fields: {
      dimensione_pollici: {
        type: "number",
        label: "Dimensione Display (pollici)",
        min: 4,
        max: 24,
        required: true,
        group: "display",
      },
      risoluzione: {
        type: "select",
        label: "Risoluzione",
        options: ["800x480", "1280x720", "1920x1080", "3840x2160"],
        required: true,
        group: "display",
      },
      tipo_display: {
        type: "radio",
        label: "Tipo Display",
        options: ["IPS", "Touchscreen", "OLED", "LCD"],
        required: true,
        group: "display",
      },
      wifi: {
        type: "boolean",
        label: "WiFi",
        group: "connettivita",
      },
      bluetooth: {
        type: "boolean",
        label: "Bluetooth",
        group: "connettivita",
      },
      nmea_2000: {
        type: "boolean",
        label: "NMEA 2000",
        group: "connettivita",
      },
      radar: {
        type: "boolean",
        label: "Radar",
        group: "connettivita",
      },
      chartplotter: {
        type: "boolean",
        label: "Chartplotter",
        group: "connettivita",
      },
      voltaggio: {
        type: "select",
        label: "Voltaggio",
        options: ["12V DC", "24V DC", "12-24V DC", "110V AC", "220V AC"],
        required: true,
        group: "alimentazione",
      },
      consumo_w: {
        type: "number",
        label: "Consumo (W)",
        min: 1,
        max: 500,
        group: "alimentazione",
      },
    },
  },
  ANC: {
    code: "ANC",
    name: "Ancoraggio",
    description: "Ancore, verricelli, catene, winch",
    category: "ANCORAGGIO",
    objectType: "accessories",
    fields: {
      tipo_ancora: {
        type: "select",
        label: "Tipo Ancora",
        options: ["Danforth", "Bruce", "CQR", "Delta", "Rocna", "Mantus"],
        required: true,
        group: "ancoraggio",
      },
      peso_kg: {
        type: "number",
        label: "Peso (kg)",
        min: 1,
        max: 100,
        required: true,
        group: "ancoraggio",
      },
      materiale: {
        type: "radio",
        label: "Materiale",
        options: ["Acciaio zincato", "Acciaio inox", "Alluminio"],
        required: true,
        group: "ancoraggio",
      },
      verricello_incluso: {
        type: "boolean",
        label: "Verricello incluso",
        group: "verricello",
      },
      potenza_verricello_w: {
        type: "number",
        label: "Potenza verricello (W)",
        min: 100,
        max: 2000,
        group: "verricello",
      },
    },
  },
  SIC: {
    code: "SIC",
    name: "Sicurezza",
    description: "Giubbotti, zattere, estintori, segnali",
    category: "SICUREZZA",
    objectType: "accessories",
    fields: {
      tipo_giubbotto: {
        type: "select",
        label: "Tipo Giubbotto",
        options: ["150N automatico", "150N manuale", "275N offshore", "100N bambino"],
        required: true,
        group: "sicurezza",
      },
      certificazione: {
        type: "checkbox",
        label: "Certificazione",
        options: ["ISO 12402", "CE", "USCG", "MED"],
        group: "sicurezza",
      },
      taglia: {
        type: "select",
        label: "Taglia",
        options: ["XS", "S", "M", "L", "XL", "XXL"],
        group: "sicurezza",
      },
    },
  },
  COM: {
    code: "COM",
    name: "Comfort",
    description: "Bimini, tendalini, cuscineria, tavoli",
    category: "COMFORT",
    objectType: "accessories",
    fields: {
      materiale: {
        type: "select",
        label: "Materiale",
        options: ["Poliestere", "Acrylic", "Vinyl", "Alluminio", "Teak"],
        required: true,
        group: "materiale",
      },
      colore: {
        type: "select",
        label: "Colore",
        options: ["Bianco", "Blu", "Grigio", "Beige", "Nero", "Verde"],
        group: "materiale",
      },
      dimensioni_cm: {
        type: "text",
        label: "Dimensioni (cm)",
        group: "misure",
      },
    },
  },
  ILL: {
    code: "ILL",
    name: "Illuminazione",
    description: "Fari, luci subacquee, LED, fanali",
    category: "ILLUMINAZIONE",
    objectType: "accessories",
    fields: {
      tipo_luce: {
        type: "select",
        label: "Tipo Luce",
        options: ["Faro", "Luce subacquea", "LED strip", "Fanale", "Luce interna"],
        required: true,
        group: "tecnico",
      },
      potenza_w: {
        type: "number",
        label: "Potenza (W)",
        min: 1,
        max: 500,
        group: "tecnico",
      },
      colore_luce: {
        type: "select",
        label: "Colore Luce",
        options: ["Bianco caldo", "Bianco freddo", "RGB", "Blu", "Rosso"],
        group: "tecnico",
      },
      impermeabile_ip: {
        type: "select",
        label: "Grado IP",
        options: ["IP65", "IP66", "IP67", "IP68"],
        group: "tecnico",
      },
    },
  },
  MOT: {
    code: "MOT",
    name: "Ricambi Motore",
        description: "Filtri, candele, pompe, cinghie",
    category: "RICAMBI",
    objectType: "accessories",
    fields: {
      compatibilita_marca: {
        type: "select",
        label: "Compatibilità Marca",
        options: ["Yamaha", "Mercury", "Suzuki", "Honda", "Volvo Penta", "Cummins"],
        required: true,
        group: "compatibilita",
      },
      compatibilita_modello: {
        type: "text",
        label: "Compatibilità Modello",
        group: "compatibilita",
      },
      tipo_ricambio: {
        type: "select",
        label: "Tipo Ricambio",
        options: ["Filtro olio", "Filtro carburante", "Candela", "Pompa acqua", "Cinghia", "Termostato"],
        required: true,
        group: "ricambio",
      },
    },
  },
  CAR: {
    code: "CAR",
    name: "Carrello",
    description: "Rimorchi, carrelli alaggio, supporti",
    category: "CARRELLO",
    objectType: "accessories",
    fields: {
      portata_kg: {
        type: "number",
        label: "Portata (kg)",
        min: 100,
        max: 5000,
        required: true,
        group: "carrello",
      },
      tipo_carrello: {
        type: "select",
        label: "Tipo Carrello",
        options: ["Rimorchio stradale", "Carrello alaggio", "Supporto statico", "Carrello regolabile"],
        required: true,
        group: "carrello",
      },
      materiale: {
        type: "radio",
        label: "Materiale",
        options: ["Acciaio zincato", "Acciaio inox", "Alluminio"],
        group: "carrello",
      },
    },
  },
  TEL: {
    code: "TEL",
    name: "Teloni",
    description: "Coprimotore, copribarca, coperture",
    category: "TELONI",
    objectType: "accessories",
    fields: {
      tipo_telone: {
        type: "select",
        label: "Tipo Telone",
        options: ["Coprimotore", "Copribarca", "Copertura totale", "Mezza copertura"],
        required: true,
        group: "telone",
      },
      materiale: {
        type: "select",
        label: "Materiale",
        options: ["Poliestere 600D", "Acrylic", "Vinyl", "PVC"],
        required: true,
        group: "telone",
      },
      impermeabile: {
        type: "boolean",
        label: "Impermeabile",
        group: "telone",
      },
      uv_resistente: {
        type: "boolean",
        label: "UV Resistente",
        group: "telone",
      },
    },
  },
  MAN: {
    code: "MAN",
    name: "Manutenzione",
    description: "Prodotti pulizia, vernici, sigillanti",
    category: "MANUTENZIONE",
    objectType: "accessories",
    fields: {
      tipo_prodotto: {
        type: "select",
        label: "Tipo Prodotto",
        options: ["Detergente", "Cera", "Antivegetativa", "Vernice", "Sigillante", "Olio"],
        required: true,
        group: "prodotto",
      },
      volume_litri: {
        type: "number",
        label: "Volume (L)",
        min: 0.1,
        max: 50,
        step: 0.1,
        group: "prodotto",
      },
      biodegradabile: {
        type: "boolean",
        label: "Biodegradabile",
        group: "prodotto",
      },
    },
  },
  SPO: {
    code: "SPO",
    name: "Sport Acquatici",
    description: "Sci nautico, wakeboard, SUP, kayak",
    category: "SPORT",
    objectType: "accessories",
    fields: {
      tipo_sport: {
        type: "select",
        label: "Tipo Sport",
        options: ["Sci nautico", "Wakeboard", "SUP", "Kayak", "Canoa", "Gonfiabile"],
        required: true,
        group: "sport",
      },
      lunghezza_cm: {
        type: "number",
        label: "Lunghezza (cm)",
        min: 50,
        max: 500,
        group: "misure",
      },
      peso_kg: {
        type: "number",
        label: "Peso (kg)",
        min: 1,
        max: 50,
        group: "misure",
      },
      persone: {
        type: "number",
        label: "Numero Persone",
        min: 1,
        max: 10,
        group: "misure",
      },
    },
  },
  PES: {
    code: "PES",
    name: "Pesca",
    description: "Canne, mulinelli, esche, sonde",
    category: "PESCA",
    objectType: "accessories",
    fields: {
      tipo_pesca: {
        type: "select",
        label: "Tipo Pesca",
        options: ["Traina", "Spinning", "Bolentino", "Surfcasting", "Fly fishing"],
        required: true,
        group: "pesca",
      },
      tipo_attrezzo: {
        type: "select",
        label: "Tipo Attrezzo",
        options: ["Canna", "Mulinello", "Esche", "Artificiali", "Sonda", "Accessori"],
        required: true,
        group: "pesca",
      },
    },
  },
  ALI: {
    code: "ALI",
    name: "Allestimento",
    description: "Scalette, passerelle, portacanne, tende",
    category: "ALLESTIMENTO",
    objectType: "accessories",
    fields: {
      tipo_allestimento: {
        type: "select",
        label: "Tipo Allestimento",
        options: ["Scaletta", "Passerella", "Portacanne", "Tenda", "Box doccia", "Frigo"],
        required: true,
        group: "allestimento",
      },
      materiale: {
        type: "select",
        label: "Materiale",
        options: ["Acciaio inox", "Alluminio", "Teak", "ABS", "Vetroresina"],
        group: "allestimento",
      },
      pieghevole: {
        type: "boolean",
        label: "Pieghevole",
        group: "allestimento",
      },
    },
  },
};

export const getAccessoryTypeSpec = (code: string): AccessoryTypeSpec | undefined => {
  return ACCESSORY_TYPE_SPECS[code?.toUpperCase()];
};

export const getAccessoryTypeName = (code: string): string => {
  return ACCESSORY_TYPE_SPECS[code?.toUpperCase()]?.name || code;
};

export const formatAccessoryType = (typeCode?: string, fallbackType?: string): string => {
  if (!typeCode) return fallbackType || "";
  return getAccessoryTypeName(typeCode) || fallbackType || typeCode;
};
